<div
  class="dialog-draggable-header"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
  [cdkDragConstrainPosition]="computeDragRenderPos.bind(this)"
>
  <mat-icon>drag_indicator</mat-icon>
</div>
<div class="release-notes-intro-header">
  <button [mat-dialog-close]="false" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="release-notes-intro-content" mat-dialog-content>
  <h2 class="release-notes-intro-title">{{ 'label_release_notes_intro_title' | translate }}</h2>
  <p class="release-notes-intro-subtitle">{{ 'label_release_notes_intro_subtitle' | translate }}</p>

  <button (click)="openReleaseNotes()" mat-flat-button color="primary">
    {{ 'label_release_notes_intro_button' | translate }}
  </button>
</div>
